module.exports = __webpack_public_path__ + "static/media/nbpreview.afb259ba.png";